<template>
  <el-card class="box-card full-screen cash-record-statistics">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('checkPending')" value="0"></el-option>
            <el-option :label="$t('getApproved')" value="1"></el-option>
            <el-option :label="$t('notApproved')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="btnStatus.isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>

      <el-row class="table-btns" v-if="loginInfo.orgType != 1">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="bankDepositApply"
          >{{ $t("bankDepositApply") }}</el-button
        >
      </el-row>
    </div>

    <!-- Data Table -->
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="table.records"
        v-loading="btnStatus.isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          width="60"
        ></el-table-column>

        <el-table-column prop="bankId" :label="$t('bankId')" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.bankId }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bankName"
          :label="$t('bankName')"
          min-width="140"
        >
          <template slot-scope="scope">
            {{ scope.row.bankName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bankAccount"
          :label="$t('bankAccount')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.bankAccount }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('bankTransaction')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0" class="text-primary">{{
              $t("bankDeposit")
            }}</span>
            <span v-if="scope.row.type == 1" class="text-warning">{{
              $t("bankWithdrawal")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="applyCode"
          :label="$t('applyCode')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.applyCode }}
          </template>
        </el-table-column>
        <el-table-column
          prop="applyAmount"
          :label="$t('applyAmount')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span>
            {{ scope.row.applyAmount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('Status')" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-warning">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createOrgName"
          :label="$t('operateOrg')"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.orgName }} ({{ scope.row.orgInfoCode }})
          </template>
        </el-table-column>
        <el-table-column
          prop="orgInfoId"
          :label="$t('Organization ID')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.orgInfoId }}
          </template>
        </el-table-column>
        <el-table-column
          prop="transfeDate"
          :label="$t('transferDate')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.transfeDate).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="applyTime"
          :label="$t('applyTime')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ $manba(scope.row.applyTime).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="applyRemark"
          :label="$t('applayRemark')"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.applyRemark }}
          </template>
        </el-table-column>
        <el-table-column
          prop="applyUser"
          :label="$t('applyUser')"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.applyUser }}
          </template>
        </el-table-column>

        <el-table-column
          prop="verifyUser"
          :label="$t('verifyUser')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyUser">{{ scope.row.verifyUser }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          min-width="160"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyTime">{{
              $manba(scope.row.verifyTime).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyRemark"
          :label="$t('verifyRemark')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyRemark">{{
              scope.row.verifyRemark
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--End Data Table-->
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="table.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isAddApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>

        <el-form-item :label="$t('bankName')" prop="bankId">
          <el-select
            size="medium"
            v-model="applyForm.bankId"
            filterable
            :placeholder="$t('selectBank')"
            style="width:100%;"
          >
            <el-option
              v-for="item in bankList"
              :key="item.id"
              :label="item.bankName"
              :value="item.id"
              v-show="item.status === 0"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="type" style="display: none;">
          <el-input v-model="applyForm.type"></el-input>
        </el-form-item>

        <el-form-item :label="$t('applyAmount')" prop="applyAmount">
          <el-input
            size="medium"
            v-model="applyForm.applyAmount"
            @input="
              applyForm.applyAmount = applyForm.applyAmount.formatMoney(0, ' ')
            "
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('transfeDate')" prop="transfeTime">
          <el-date-picker
            v-model="applyForm.transfeTime"
            type="datetime"
            :time-arrow-control="true"
            :format="'yyyy-MM-dd HH:mm:ss'"
            :placeholder="$t('selectDateAndTime')"
            style="width:100%"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('applayRemark')" prop="remark">
          <el-input
            type="textarea"
            size="medium"
            v-model="applyForm.remark"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="btnSend.isLoading"
            @click="onSubmitAdd('applyForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import bank from "@/api/bank";
import manba from "@/assets/uilt/manbaDate";

export default {
  name: "bankDepositApply",
  data() {
    return {
      //table高度，动态设置
      queryTableHeight: String,
      queryForm: {
        //date: [new Date(this.$manba().format('ym') + "-01"), new Date()]
      },

      btnStatus: { isLoading: false },
      btnSend: { isLoading: false },

      table: {
        records: [{}],
      },
      bankList: [],

      pageSize: 20,
      currentPage: 1,

      applyTitle: "bankDepositApply",
      applyForm: {
        type: 0,
      },

      isAddApply: false,

      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: (time) => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    rules() {
      return {
        bankId: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        applyAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        //bankTransferserial: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
        transfeTime: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        //businessCode: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
      };
    },
  },

  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    },
  },

  methods: {
    getList() {
      let _this = this;
      //_this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      bank.getBankDepositInfoPage({
        param: {
          current: _this.table.currentPage,
          size: _this.table.pageSize,
          ...params,
        },
        success: (res) => {
          _this.table = res.data || {};
          //_this.isLoading = false;
        },
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: (time) => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          },
        };
      }
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    bankDepositApply() {
      this.isAddApply = true;
      //this.applyTitle = title;
    },
    /**提交充值申请 */
    onSubmitAdd(refName) {
      let _this = this;
      _this.isLoading = true;
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this[refName].transfeTime = manba(_this[refName].transfeTime).format(
          "ymdhms",
        );
        bank.addBankInfoApply({
          param: _this[refName],
          success: (res) => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.isAddApply = false;
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          },
        });
      });
    },
    getBankList() {
      let _this = this;
      bank.getAllBank({
        success: (res) => {
          if (res.code != 200) return;
          _this.bankList = res.data;
        },
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();
    this.getBankList();
  },
};
</script>

<style lang="less" scoped></style>
